import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const LockedOverlay = ({ message = "Members-only content" }) => {
  const { user } = useAuth();
  const hasProfile = user?.has_health_profile;
  const ctaTo = hasProfile ? "/pricing" : "/health-profile";
  const ctaLabel = hasProfile ? "Activate access" : "Complete profile first";

  return (
    <div
      className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center p-6 glass border border-white/60 rounded-2xl"
      data-testid="locked-overlay"
    >
      <div className="w-12 h-12 rounded-full bg-moss text-white grid place-items-center mb-3 shadow-ambient">
        <Lock size={20} />
      </div>
      <p className="font-heading font-semibold text-ink mb-3">{message}</p>
      <Link
        to={ctaTo}
        data-testid="locked-cta"
        className="bg-terra hover:bg-terra-dark text-white rounded-full px-5 py-2 text-sm font-semibold transition-all active:scale-95"
      >
        {ctaLabel}
      </Link>
    </div>
  );
};
